import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { ContainerProps } from './Container.types';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${(props: ContainerProps) => {
    // add any more responsive/non-responsive rules here
    if (props.responsive) {
      return `
      padding: 5%;

      @media (max-width: 1000px) {
        padding: 0;
      }`;
    } else {
      return `
        padding: 2rem;
      `;
    }
  }}
`;

export const Container: FunctionComponent<ContainerProps> = props => {
  return <StyledContainer {...props} />;
};

Container.defaultProps = {
  responsive: true,
};
